const NextSlideButton = () => (
    <div className="promotions__swiper-button-next" tabIndex="0" role="button" aria-label="Next slide">
        <i className="icon icon--arrow-right" role="desktop-visible" />
    </div>
);

export default NextSlideButton;
